import { gql } from '@apollo/client'

// Query to get a list of wallets based on filters
export const WALLETS_QUERY = gql`
  query Wallets($filters: WalletFilters!) {
    wallets(filters: $filters) {
      walletID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      walletType
      isBilateral
      currency
      walletBalance
      remainingCreditBalance
      active
    }
  }
`

// Query to get a specific wallet by ID
export const WALLET_QUERY = gql`
  query Wallet($walletID: ID!) {
    wallet(walletID: $walletID) {
      walletID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      walletType
      isBilateral
      currency
      walletBalance
      remainingCreditBalance
      remainingReservable
      maxCredit
      macReservable
      canUseCredit
      autoSettelmentEnabled
      active
    }
  }
`

// Query to get a brief list of wallets based on filters
export const WALLETS_BRIEF_QUERY = gql`
  query WalletsBrief($filters: WalletFilters) {
    walletsBrief(filters: $filters) {
      walletID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      walletType
      currency
      isBilateral
    }
  }
`

export const CREATE_WALLET_MUTATION = gql`
  mutation CreateWallet($input: WalletInput!) {
    createWallet(input: $input) {
      message
    }
  }
`

export const CREATE_WALLETS_FOR_SUB_MUTATION = gql`
  mutation CreateWalletsForSubscribe($input: CreateWalletsForSubscribeInput!) {
    createWalletsForSubscribe(input: $input) {
      message
    }
  }
`
